/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPlayBack: {
  name: 'play-back';
  data: string;
} = {
  name: 'play-back',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.212 2.547A.5.5 0 0 1 11.5 3v10a.5.5 0 0 1-.82.384l-6-5a.5.5 0 0 1 0-.768l6-5a.5.5 0 0 1 .532-.069ZM5.781 8l4.719 3.932V4.068L5.781 8Z" fill="currentColor"/></svg>`,
};
